import React, { PureComponent } from 'react'
import { string, arrayOf, shape } from 'prop-types'
import { Text } from 'components'
import { Panel } from './index'

export class PanelList extends PureComponent {
    static propTypes = {
        title: string,
        list: arrayOf(shape({
            name: string.isRequired,
            text: string.isRequired
        }))
    }

    state = {
        hide: false
    }

    componentWillMount() {
        this.prevTitle = this.props.title
        this.prevList = this.props.list
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.title && nextProps.title !== this.props.title) {
            this.clearTimeout()
            this.prevTitle = this.prevTitle || nextProps.title
            this.prevList = this.prevList || nextProps.list
            this.setState({ hide: true })
            this.timeout = setTimeout(() => {
                this.prevTitle = nextProps.title
                this.prevList = nextProps.list
                this.setState({ hide: false })
            }, 250)
        }
    }
    componentWillUnmount() {
        this.clearTimeout()
    }
    clearTimeout() {
        this.timeout && clearTimeout(this.timeout)
    }

    renderItem({ name, text }, index) {
        return <li key={index}><Text tag="span"><strong>{name}:</strong> {text}</Text></li>
    }
    render() {
        const { title, list, className, ...otherProps } = this.props
        const { hide } = this.state
        return (
            <Panel className={['PanelList Scrollable', className, { Hide: hide }]} {...otherProps}>
                <div className="Panel-ScrollableContent">
                    <Text className="Panel-Title">{this.prevTitle}</Text>
                    <ul>
                        {(this.prevList || []).map(this.renderItem)}
                    </ul>
                </div>
            </Panel>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Panel/PanelList.js